import React, { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { Cnt } from "../../Cnt.ThreeDeeCrate.SDK/Cnt.ThreeDeeCrate.SDK";
import { FakeProgressBar } from "./FakeProgressBar";
import { GenerationStatusBadge } from "../GenerationStatusBadge";
import { AppSettings } from "../../AppSettings";
import { EMPTY_GUID } from "../../types/Guid";
import { RecommendedStarButton } from "../Buttons/RecommendedStarButton";

interface Props {
  containerId: string;
  status: Cnt.ThreeDeeCrate.SDK.GenerationStatusType | null;
  height?: string;
  name?: string;
  description?: string;
  smallThumbnail: boolean;
  isRecommended: boolean;
}

export const ThumbnailProgress: React.FC<Props> = ({
  containerId,
  status,
  height = "100%", // default
  name,
  description,
  smallThumbnail = false, // default to full-size
  isRecommended
}) => {
  const isGenerating: boolean =
    status !== undefined &&
    status !== null &&
    status !== Cnt.ThreeDeeCrate.SDK.GenerationStatusType.Done;

  const showProgressBar =
    status !== Cnt.ThreeDeeCrate.SDK.GenerationStatusType.Done &&
    status !== Cnt.ThreeDeeCrate.SDK.GenerationStatusType.Queued &&
    status !== Cnt.ThreeDeeCrate.SDK.GenerationStatusType.ToBeGenerated;

  const [thumbnailUrl, setThumbnailUrl] = useState<string>("/placeholder.png");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!containerId || containerId === EMPTY_GUID)
      return;

    const fetchThumbnail = async () => {
      try {
        const fileName = smallThumbnail ? "thumbnail_sm.png" : "thumbnail.png";
        const url =
          "https://s3.us-east-2.amazonaws.com/3dcrate.com/uploads/" +
          containerId +
          "/" +
          fileName;

        const img = new Image();
        img.onload = () => {
          setThumbnailUrl(url);
          setLoading(false);
        };
        img.onerror = () => {
          console.error("❌ Failed to load thumbnail image");
          setThumbnailUrl("/placeholder.png");
          setLoading(false);
        };
        img.src = url;
      } catch (err) {
        console.error("❌ Error fetching thumbnail:", err);
        setThumbnailUrl("/placeholder.png");
        setLoading(false);
      }
    };

    fetchThumbnail();
  }, [containerId]);

  return (
    <div className="position-relative w-100 rounded" style={{ overflow: "hidden", height, minHeight:"121px", width:'100%' }}>
      {/* Overlayed Text */}
      {(name || description) && (
        <div
          style={{
            position: "absolute",
            top: 8,
            left: 12,
            zIndex: 2,
            color: "white",
            textShadow: "0 0 3px black",
            maxWidth: "80%",
          }}
        >
          {name && <div style={{ fontWeight: "bold", fontSize: "1rem" }}>{name}</div>}
          {description && <div style={{ fontSize: "0.85rem" }}>{description}</div>}
        </div>
      )}

      {/* Loading Spinner */}
      {loading ? (
        <div className="d-flex justify-content-center align-items-center w-100 h-100 bg-dark bg-opacity-25">
          <Spinner animation="border" variant="light" />
        </div>
      ) : (
        <img
          src={thumbnailUrl}
          alt="Model Thumbnail"
          className="w-100 h-100"
          style={{
            objectFit: "cover",
            filter: isGenerating ? "brightness(40%)" : "none",
            transition: "filter 0.3s ease-in-out",
          }}
        />
      )}
  {/* ⭐ Star in top-left */}
  <RecommendedStarButton modelId={containerId} initialIsRecommended={isRecommended} />
      {/* Badge and Progress */}
      <GenerationStatusBadge status={status} />
      <FakeProgressBar isActive={isGenerating && showProgressBar} />
    </div>
  );
};
